import { Injectable } from '@angular/core';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alertSubject = new Subject<{ message: string; type: string }>();
  alert$ = this.alertSubject.asObservable();

  showAlert(
    message: string,
    type: 'success' | 'info' | 'warning' | 'error' = 'info'
  ) {
    this.alertSubject.next({ message, type });
  }
}
